export const initScrollSwiper = (slider) => {

    const track = slider.querySelector('.js-scroll-swiper-track');
    const prev = slider.querySelector('.js-scroll-swiper-prev');
    const next = slider.querySelector('.js-scroll-swiper-next');
    const scrollWidth = track.firstElementChild.clientWidth;


    const prevClick = () => {
        track.scrollBy({left: '-' + scrollWidth, behavior: 'smooth'});
    };

    const nextClick = () => {
        track.scrollBy({left: scrollWidth, behavior: 'smooth'});
    };

    if (track && prev && next) {
        prev.addEventListener('click', () => {
            prevClick();
        });
        next.addEventListener('click', () => {
            nextClick();
        });

        const scrollTrackWidth = track.clientWidth;
        const scrollTrackScrollWidth = track.scrollWidth;

        const checkScrollPosition = () => {
            const scrollLeft = track.scrollLeft;

            if (scrollLeft === 0) {
                prev.classList.add('scroll-slider__prev--disabled');
            } else {
                prev.classList.remove('scroll-slider__prev--disabled');
            }

            if ((scrollLeft + scrollTrackWidth + 10) >= scrollTrackScrollWidth) {
                next.classList.add('scroll-slider__next--disabled');
            } else {
                next.classList.remove('scroll-slider__next--disabled');
            }
        };

        checkScrollPosition();
        track.addEventListener('scroll', checkScrollPosition);
    }
}

[...document.querySelectorAll('.js-scroll-swiper')].map(initScrollSwiper);
